<template>
    <div>
        <swiper :options="swiperOptions">
            <swiper-slide v-for="(item, index) in list" :key="index">
                <img :src="item.imgUrl" class="pic">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"/>
        </swiper>
    </div>
</template>

<script>
    /*todo 輪播組件Swiper只支援vue3，要另外用外掛vue-awesome-swiper
       demo https://github.surmon.me/vue-awesome-swiper/
       swiper4-6功能中文網 https://www.swiper.com.cn/api/autoplay/19.html*/
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        name: "StallPhotoSlider",
        props: {
            list: { type:Array, default: Array.of([]) },  // list = [url:string, imgUrl:string]
            imgUrl: {default: ''},
        },
        components: {
            Swiper,
            SwiperSlide
        },
        computed: {

        },
        data() {
            return {
                //輪播用
                swiperOptions: {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                },
            }
        },
        mounted() {

        },
        methods: {

        }

    }
</script>

<style scoped lang="less">
    //輪播用
    /deep/.swiper-container{
        .pic{
            width: 100%;
        }
        .swiper-pagination{
            .swiper-pagination-bullet-active{
                background: var(--color-yellow);
            }
        }
        .swiper-slide{
            margin: auto 0;
        }
    }
</style>
